// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Fresnel$PrezzeeRibbon from "../../../bindings/Fresnel/Fresnel.bs.js";

var image = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.position("absolute"),
      BsCssJs$PrezzeeRibbon.top(BsCssJs$PrezzeeRibbon.zero),
      BsCssJs$PrezzeeRibbon.left(BsCssJs$PrezzeeRibbon.zero),
      BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.pct(100)),
      BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.pct(100)),
      BsCssJs$PrezzeeRibbon.objectFit("cover")
    ]);

var Styles = {
  image: image
};

function StatsTile__Background(props) {
  var backgroundImageMobile = props.backgroundImageMobile;
  var backgroundImage = props.backgroundImage;
  if (backgroundImageMobile !== undefined) {
    return JsxRuntime.jsxs(JsxRuntime.Fragment, {
                children: [
                  JsxRuntime.jsx(Fresnel$PrezzeeRibbon.Media.make, {
                        greaterThan: "rbMobile",
                        children: JsxRuntime.jsx("img", {
                              className: image,
                              src: backgroundImage
                            })
                      }),
                  JsxRuntime.jsx(Fresnel$PrezzeeRibbon.Media.make, {
                        at: "rbMobile",
                        children: JsxRuntime.jsx("img", {
                              className: image,
                              src: backgroundImageMobile
                            })
                      })
                ]
              });
  } else {
    return JsxRuntime.jsx("img", {
                className: image,
                src: backgroundImage
              });
  }
}

var make = StatsTile__Background;

export {
  Styles ,
  make ,
}
/* image Not a pure module */
